import { ButtonTypeTokens, ColorTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, WIDGET, } from '@voltmoney/schema';
import React from 'react';
import { Typography } from '../typography/Typography';
export const args = {
    header: {
        children: (React.createElement(Typography, { label: 'header', color: ColorTokens.Grey_100 })),
        widgetItems: [
            {
                id: 'button',
                type: WIDGET.BUTTON,
                props: {
                    type: ButtonTypeTokens.SmallFilled,
                    label: 'hello stack',
                },
            },
        ],
    },
    body: {
        children: (React.createElement(Typography, { label: 'header', color: ColorTokens.Grey_300 })),
    },
    footer: {
        children: (React.createElement(Typography, { label: 'header', color: ColorTokens.Blue_300 })),
    },
    bgColor: ColorTokens.Grey_600,
    onPress: Function,
    padding: {
        top: SizeTypeTokens.LG,
        bottom: SizeTypeTokens.LG,
        left: SizeTypeTokens.XL,
        right: SizeTypeTokens.XL,
    },
    alignItems: StackAlignItems.center,
    justifyContent: StackJustifyContent.center,
};
export const argTypes = {
    bgColor: {
        control: 'select',
        options: [
            ...Object.values(ColorTokens).filter((k) => typeof k === 'string'),
        ],
    },
    alignItems: {
        control: 'select',
        options: [...Object.values(StackAlignItems)],
    },
    justifyContent: {
        control: 'select',
        options: [
            ...Object.values(StackJustifyContent),
        ],
    },
};
